module.exports = __webpack_public_path__ + "media/packs/images/white-arrow-icon-a2ee438f398bf25e04a35176f2cdb235.svg";